import { all, takeEvery } from 'redux-saga/effects'

import { ApiKeysActions } from '../actions'
import { createApiKey } from './createApiKey'
import { fetchApiKeys } from './fetchApiKeys'
import { revokeApiKey } from './revokeApiKey'

export function* apiKeysSaga() {
  yield all([
    takeEvery(ApiKeysActions.fetch, fetchApiKeys),
    takeEvery(ApiKeysActions.create, createApiKey),
    takeEvery(ApiKeysActions.revoke, revokeApiKey),
  ])
}
